'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _createTemplateComponent = require('helpers/createTemplateComponent');

var _createTemplateComponent2 = _interopRequireDefault(_createTemplateComponent);

var _components = require('components');

var _props4 = require('../props');

var _common = require('../../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Editor = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Editor, _Component);

  function Editor() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Editor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).call.apply(_ref, [this].concat(args))), _this), _this._selectComponent = function (event) {
      event.stopPropagation();
      var _this$props = _this.props,
          id = _this$props.id,
          selectComponent = _this$props.selectComponent;

      if (typeof selectComponent === 'function') selectComponent(id);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Editor, [{
    key: '_getStyle',
    value: function _getStyle() {
      var additionalProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props = this.props,
          padding = _props.padding,
          margin = _props.margin;


      return (0, _reactcss2.default)({
        default: {
          container: {
            padding: padding,
            margin: margin
          }
        }
      }, this.props, additionalProps);
    }
  }, {
    key: '_renderChildren',
    value: function _renderChildren() {
      var _props2 = this.props,
          childComponents = _props2.childComponents,
          id = _props2.id,
          direction = _props2.direction;


      if (!childComponents) return this.props.children || null;

      return childComponents.map(function (child, index) {
        var _child$xs = child.xs,
            xs = _child$xs === undefined ? 12 : _child$xs,
            _child$sm = child.sm,
            sm = _child$sm === undefined ? 12 : _child$sm,
            _child$md = child.md,
            md = _child$md === undefined ? 12 : _child$md,
            _child$lg = child.lg,
            lg = _child$lg === undefined ? 12 : _child$lg;

        var key = 'tq-plus-admin-container-editor-' + id + '-child-' + index;
        var ChildComponent = (0, _createTemplateComponent2.default)(child);

        if (!ChildComponent) return null;

        return direction === _props4.DIRECTIONS.HORIZONTAL ? _react2.default.createElement(
          _components.EnterpriseGrid.Col,
          { key: key, xs: xs, sm: sm, md: md, lg: lg },
          _react2.default.createElement(ChildComponent, null)
        ) : _react2.default.createElement(
          _components.EnterpriseGrid.Row,
          { key: key },
          _react2.default.createElement(
            _components.EnterpriseGrid.Col,
            { xs: xs, sm: sm, md: md, lg: lg },
            _react2.default.createElement(ChildComponent, null)
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          direction = _props3.direction;

      var style = this._getStyle();
      var styles = require('./Editor.scss');

      return _react2.default.createElement(
        _common.EditorComponentWrapper,
        { className: styles.wrapper, isSelectable: false },
        _react2.default.createElement(
          _components.EnterpriseGrid,
          {
            className: (0, _classnames2.default)(className, styles.root),
            style: style.container,
            onClick: this._selectComponent
          },
          direction === _props4.DIRECTIONS.HORIZONTAL ? _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            null,
            this._renderChildren()
          ) : this._renderChildren()
        )
      );
    }
  }]);
  return Editor;
}(_react.Component), _class.propTypes = _props4.propTypes, _class.defaultProps = _props4.defaultProps, _temp2);
exports.default = Editor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/ContainerNoProps/Editor/Editor.jsx
// module id = 1511
// module chunks = 0